var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyleFooter, GlobalStyleFooterText } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/pro-regular-svg-icons/faDatabase';
import { faSlidersVSquare } from '@fortawesome/pro-regular-svg-icons/faSlidersVSquare';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
var EnvMessages = function () {
    return (_jsxs(GlobalStyleFooter, { children: [_jsx(GlobalStyleFooterText, __assign({ muted: true }, { children: "You can always change this later in" })), _jsx(FontAwesomeIcon, { color: "#353535", size: "sm", icon: faDatabase }), _jsx(GlobalStyleFooterText, { children: "Data" }), _jsx(FontAwesomeIcon, { color: "#828282", size: "sm", icon: faChevronRight }), ' ', _jsx(FontAwesomeIcon, { color: "#828282", size: "sm", icon: faSlidersVSquare }), _jsx(GlobalStyleFooterText, { children: "Environment" })] }));
};
export default EnvMessages;
